import {create} from "zustand";
import {createJSONStorage, persist} from "zustand/middleware";

import {customStorage} from "@/src/modules/core/lib";
import type {Session} from "@/src/modules/auth/types";

type SessionState = {
  session: Session | null;
};

type SessionActions = {
  setSession: (session: Session | null) => void;
  clearSession: () => void;
};

type SessionStore = SessionState & SessionActions;

export const useSessionStore = create<SessionStore>()(
  persist(
    (set) => ({
      session: null,

      setSession: (session: Session | null) => {
        set({
          session,
        });
      },

      clearSession: () => {
        set({
          session: null,
        });
      },
    }),
    {
      name: "session-store",
      // storage: createJSONStorage(() => customStorage),
      partialize: (state) => {
        return {session: state.session};
      },
      merge: (persistedState: any, currentState: any) => ({
        ...currentState,
        ...persistedState,
      }),
    },
  ),
);

export function useStoredSession() {
  return useSessionStore((state) => state.session);
}

export function useIsAuthenticated() {
  return !!useStoredSession();
}

const SESSION_STORE_KEY = "session-store";

/** Write current session to localStorage immediately (zustand persist can lag before reload). */
export function persistSessionStoreSync(): void {
  if (typeof localStorage === "undefined") return;

  const {session} = useSessionStore.getState();
  localStorage.setItem(
    SESSION_STORE_KEY,
    JSON.stringify({
      state: {session},
      version: 0,
    }),
  );
}
